import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

//here just create for attractionlist

const initialState = {
  dashboardStats: {
    Arrivals: 0,
    Departures: 0,
    out_of_order_count: 0,
    availableRooms: 0,
    cleanRooms: 0,
    occupancy: "0%",
    adr: "$ 0",
    revpar: "$ 0",
    totalRevenue: "$ 0",
    firsttime: true,
  },
  seleDate: moment(new Date())?.format("YYYY-MM-DD"),
  seleEndDate: moment(new Date()).add(7, "days")?.format("YYYY-MM-DD"),
  propertyList: [],
  propertyListReport: [],
  dashboardReservations: [
    {
      date: moment(new Date())?.format("YYYY-MM-DD"),
      day: "",
      total_rooms: 0,
      available: 0,
      booked: 0,
    },
  ],
};

const ownerdashboardSlice = createSlice({
  name: "ownerdashboard",
  initialState: initialState,
  reducers: {
    dashboardStatsSuccess: (state, action) => {
      state.dashboardStats = action.payload;
    },
    seleDateSuccess: (state, action) => {
      state.seleDate = action.payload;
    },
    seleEndDateSuccess: (state, action) => {
      state.seleEndDate = action.payload;
    },
    propertyListSuccess: (state, action) => {
      state.propertyList = action.payload;
    },
    propertyListReportSuccess: (state, action) => {
      state.propertyListReport = action.payload;
    },
    dashboardReservationsSuccess: (state, action) => {
      state.dashboardReservations = action.payload;
    },
  },
});

export const {
  dashboardStatsSuccess,
  seleDateSuccess,
  seleEndDateSuccess,
  propertyListSuccess,
  propertyListReportSuccess,
  dashboardReservationsSuccess,
} = ownerdashboardSlice.actions;

export default ownerdashboardSlice.reducer;
